<template>
  <div
    class="tabs"
    v-if="presentation.isEnablePrivateFeedback"
    :class="{
      light: isLightTheme,
      dark: !isLightTheme
    }"
  >
    <div
      class="tabs-container"
      :class="{
        light: isLightTheme,
        dark: !isLightTheme
      }"
    >
      <div class="nav-tabs">
        <div
          class="nav-item"
          :class="{
            active: activeTabView === 'slide',
            light: isLightTheme,
            dark: !isLightTheme
          }"
          :open-on-click="false"
          @click="handleSwitchTab('slide')"
        >
          <aha-icon
            name="present"
          />
        </div>
        <div
          class="nav-item"
          :class="{
            active: activeTabView === 'feedback',
            light: isLightTheme,
            dark: !isLightTheme
          }"
          @click="handleSwitchTab('feedback')"
        >
          <aha-icon
            name="feedback"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import util from '../util'

export default {
  computed: {
    ...mapState({
      activeTabView: (state) => state.activeTabView,
      presentation: (state) => state.presentation,
      slide: (state) => state.slide,
    }),
    isLightTheme() {
      return this.slide.textColour === '#313131'
    },
  },

  methods: {
    handleSwitchTab(tab) {
      this.$store.state.activeTabView = tab
      util.gaTrackEvent('Audience', 'Main screen > Switch tab', tab)
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs {
  &.light {
    border-bottom: 1px solid #ddd;

  }
  &.dark {
    border-bottom: 1px solid #666;

  }
}

.tabs-container {
  width: 100%;
  &.light {
    background: #eff1f7
  }

  &.dark {
    background: #464646
  }
}

.nav-tabs {
  display: flex;
  max-width: 710px;
  margin: 0 auto;
  color: #B4BCCF;

  .nav-item {
    padding: 14px;
    flex: 0 0 50%;
    text-align: center;
    background-color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &.light {
      background: #eff1f7;
      color: rgba(0, 0, 0, 0.2);
      &.active {
        background: #fff;
        color: #191F2D;
      }
    }
    &.dark {
      background: #464646;
      color: rgba(255, 255, 255, 0.3);
      &.active {
        background: darken(#464646, 8%);
        color: #fff;
    }
    }
  }
}
</style>
